import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { interval } from 'rxjs';
import { SERVICE_DESK_URL } from '../injection-tokens';
import { MainLayoutComponent } from '../main-layout/main-layout.component';
import { BackendPokerService } from './backend-poker.service';

@Component({
  templateUrl: 'backend-unreacheable.component.html',
  styleUrls: ['./backend-unreacheable.component.scss'],
  standalone: true,
  imports: [MainLayoutComponent, MatIconModule, MatButtonModule, TranslatePipe],
})
export class BackendUnreacheableComponent implements OnInit {
  showTechDetails = false;
  dbWorking: boolean;
  storageWorking: boolean;
  secondsBeforeRedirect = 30;
  readonly supportUrl!: string;

  constructor(
    private readonly backendPoker: BackendPokerService,
    private readonly router: Router,
    @Inject(SERVICE_DESK_URL) private readonly serviceDeskUrl: string,
  ) {
    this.supportUrl = serviceDeskUrl;
  }

  async ngOnInit(): Promise<void> {
    this.backendPoker.pokeBackend().then((backendStatus) => {
      this.dbWorking = backendStatus.db;
      this.storageWorking = backendStatus.storage;

      if (this.dbWorking && this.storageWorking) {
        const everySec$ = interval(1000);
        const sub = everySec$.subscribe(() => {
          this.secondsBeforeRedirect--;
          if (this.secondsBeforeRedirect === 0) {
            sub.unsubscribe();
            this.router.navigate([`/dashboard`]);
          }
        });
      }
    });
  }
}
